import { createGetAsyncSlice } from '@sonar-software/xuder';
import { getSonarObjectPageLayouts } from '@api';
import { updateSonarObjectReferences } from '../_idMap/actions';

export const getCoreSonarObjectsPageLayoutsAsyncSlice = createGetAsyncSlice({
	httpSagaOptions: {
		cache: true,
		successCombinationActionCreators: [
			(request, data) => updateSonarObjectReferences([ {
				salesforce: {
					pageLayouts: data
				},
				sonarObjectId: request.sonarObjectId
			} ])
		]
	},
	name: 'CoreSonarObjectsPageLayouts',
	receive: true,
	request: true,
	requestHandler: getSonarObjectPageLayouts
});
